// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__1v1in","pencil":"IconEdit_pencil__2cpkA"};